/**
 * AbortError を抑制するためのエラーハンドラー
 * Firestore のリスナー中断時に発生するエラーを非表示にする
 */

if (typeof window !== 'undefined') {
  // 1. console.error をオーバーライド
  const originalConsoleError = console.error;
  console.error = (...args: any[]) => {
    const message = args.map(arg => String(arg)).join(' ');
    if (
      message.includes('aborted') ||
      message.includes('AbortError') ||
      message.includes('signal is aborted') ||
      message.includes('The user aborted a request')
    ) {
      // AbortError は無視（ログも出さない）
      return;
    }
    originalConsoleError.apply(console, args);
  };

  // 2. グローバルエラーハンドラー
  window.addEventListener('error', (event) => {
    const message = event.message || event.error?.message || '';
    if (
      message.includes('aborted') ||
      message.includes('AbortError') ||
      message.includes('signal is aborted')
    ) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return false;
    }
  }, true);

  // 3. Promise rejection ハンドラー
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    const message = reason?.message || reason?.toString() || '';
    const name = reason?.name || '';
    
    if (
      name === 'AbortError' ||
      message.includes('aborted') ||
      message.includes('signal is aborted') ||
      message.includes('The user aborted a request')
    ) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return false;
    }
  }, true);
}

export {};
